@if (form) {
  <div [formGroup]="form" class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <label for="label" class="font-semibold w-full"
        >{{ "fault_allocation.controller_catalog.manufacturer_form.label" | translate }}*</label
      >
      <input pInputText id="label" formControlName="label" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="notes" class="font-semibold w-full">{{
        "fault_allocation.controller_catalog.manufacturer_form.notes" | translate
      }}</label>
      <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true" id="notes"></textarea>
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
    </div>
  </div>
}
